$(document).ready(function () {
    $('.btn-report-error').on('click', function () {
        showDocumentReportModal();
    });
});


function showDocumentReportModal() {
    var search_id = $("#search-id-id").val();
    var order_id = $("#order-id").val();
    var document_id = $("#document-id").val();

    // parameters
    var dataString = "orderId=" + order_id + "&searchId=" + search_id + '&documentId=' + document_id;

    var modal = $("#document-report-modal");
    var modalInner = modal.find('.modal_content_inner');

    // get the data
    $.get('/document-reports/report-document-error/?' + dataString, function (data) {
        modalInner.html(data);
        modal.modal('show');
        modalInner.find('form').submit(function (event) {
            // prevent the default submit from happening
            event.preventDefault();

            var data = $(this).serialize();

            // post a response to the controller, but capture its output.  Don't redirect!
            $.post('/document-reports/report-document-error/?' + dataString, data, function (response) {
                modalInner.html(response);
            });

        });
    });

}

